import { useContext, useMemo } from 'react';
import { Link, useParams } from 'react-router-dom';
import ProductCard from './ProductCard';
import Loader from '../shared/Loader';
import SEO from '../shared/SEO';
import { CATEGORY_LANDINGS } from '../../config/siteContent';
import { CategoryContext } from '../../providers/CategoryContext';
import { ProductContext } from '../../providers/ProductContext';

const CategoryLanding = ({ slug: configuredSlug }) => {
  const { slug: routeSlug } = useParams();
  const slug = configuredSlug || routeSlug;
  const landing = CATEGORY_LANDINGS[slug];
  const { categories, loading } = useContext(CategoryContext);
  const { products } = useContext(ProductContext);

  const category = useMemo(() => {
    if (!landing?.categoryName) return null;
    return categories.find((item) => item.name === landing.categoryName) || null;
  }, [categories, landing]);

  const landingProducts = useMemo(() => {
    if (!landing) return [];
    return products.filter((product) => {
      if (landing.categoryName) return product.category?.name === landing.categoryName;
      return product.subcategory === landing.subcategoryName;
    });
  }, [landing, products]);

  if (!landing) {
    return (
      <main className="info-page">
        <section className="info-page-content">
          <h1>Categoría no encontrada</h1>
          <Link className="info-page-secondary-cta" to="/tienda">Volver a la tienda</Link>
        </section>
      </main>
    );
  }

  if (loading) return <Loader />;

  return (
    <>
      <SEO
        title={landing.title}
        description={landing.description}
        url={landing.path}
        breadcrumbs={[
          { name: 'Inicio', url: '/' },
          { name: landing.h1, url: landing.path }
        ]}
      />
      <main className="category-landing">
        <header className="category-landing-header">
          <div className="container">
            <h1>{landing.h1}</h1>
            <p>{landing.intro}</p>
            {category?.description && <p className="category-landing-description">{category.description}</p>}
          </div>
        </header>
        <section className="container category-landing-products" aria-label={`Productos de ${landing.h1}`}>
          {landingProducts.length ? (
            <div className="products-grid store-products-grid">
              {landingProducts.map((product) => (
                <div key={product._id} className="product-item-enhanced">
                  <ProductCard product={product} />
                </div>
              ))}
            </div>
          ) : (
            <div className="no-products-content">
              <h2>Próximamente habrá productos disponibles</h2>
              <Link className="info-page-secondary-cta" to="/tienda">Ver toda la tienda</Link>
            </div>
          )}
        </section>
      </main>
    </>
  );
};

export default CategoryLanding;
